<template>
  <a href="https://querobolsa.com.br" class="logo">
    <img
      src="~/assets/images/quero.svg"
      alt="Logo Querobolsa"
      width="182"
      height="48"
    >
  </a>
</template>

<style lang="scss" scoped>
  .logo {
    align-items: center;
    display: flex;
  }
</style>

<script>
  export default {

  }
</script>
